import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { ShadowlessElement } from '@blocksuite/std';
import { html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

import {
  emptyStateCtaStyle,
  emptyStateHintStyle,
  emptyStateStyle,
  emptyStateTitleStyle,
} from '../../../shared/empty-state/empty-state-css.js';

/**
 * Shown when the gantt has zero rows. The CTA delegates to the parent
 * so row creation runs through the same signal/pipeline as the
 * header-widget "+ Add row" button.
 */
export class GanttEmptyDb extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor onCreate: (() => void) | undefined;

  override connectedCallback(): void {
    super.connectedCallback();
    this.classList.add(emptyStateStyle);
  }

  override render(): TemplateResult {
    return html`
      <div class=${emptyStateTitleStyle}>No tasks yet</div>
      <div class=${emptyStateHintStyle}>
        Add your first task and pick its start and end dates to see it on the
        gantt.
      </div>
      <button class=${emptyStateCtaStyle} @click=${() => this.onCreate?.()}>
        Add first task
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'dv-gantt-empty-db': GanttEmptyDb;
  }
}
